import { createResource } from '../core'
import { projectsService } from './projects.service'

/** TanStack Query for projects: `useProjects({ accountId, search, page })`, `useAllProjects()`, `useProject(id)`, and the write hooks. */
export const projects = createResource('projects', projectsService)

export const projectsKeys = projects.keys
export const projectsQueries = projects.queries
export const useProjects = projects.useList
export const useAllProjects = projects.useAll
export const useProject = projects.useOne
export const useCreateProject = projects.useCreate
export const useUpdateProject = projects.useUpdate
export const useDeleteProject = projects.useRemove
